import { render, staticRenderFns } from "./unpassList.vue?vue&type=template&id=8ef48728&scoped=true"
import script from "./unpassList.vue?vue&type=script&lang=js"
export * from "./unpassList.vue?vue&type=script&lang=js"
import style0 from "./unpassList.vue?vue&type=style&index=0&id=8ef48728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef48728",
  null
  
)

export default component.exports